import  * as XLSX from 'xlsx';
export const frontEndExportMixin = {
    methods: {
        // 导出表格 data=数据 fileName=导出文件名
        mixin_exportToCsv(data, fileName='data.csv') {
          // 将数据转换为工作表
          const ws = XLSX.utils.json_to_sheet(data);
          // 创建新的工作簿并添加工作表
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    
          // 导出工作簿
          XLSX.writeFile(wb, fileName);
        }
      }
}